/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form, InputNumber, Space, Typography } from 'antd';
import EntryPointSelect from '../../../Forms/Fields/EntryPointSelect';
import { InfoCircleOutlined } from '@ant-design/icons';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';
import { ACTIVITY_TYPES } from '../../../../constants/main';

// Constant declarations
const { Text } = Typography;

const UserFeedbackNodeAAForm = ({
  form,
  responseIndex,
  canEdit,
  setHasPendingChanges
}) => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      <Space className="mb-3 mt-1">
        <InfoCircleOutlined className="text-secondary" />
        <Text className="text-secondary">{t('Agent will redirect to the selected Feedback Flow')}</Text>
      </Space>

      <Form.Item
        validateTrigger={['onChange', 'onBlur']}
        rules={[
          {
            required: true,
            message: t('Redirect target cannot be blank.')
          }
        ]}
        name={[responseIndex, 'jumpTo']}
      >
        <EntryPointSelect
          size="large"
          className="fs-base"
          activityTypesToDisplay={[ACTIVITY_TYPES.USER_FEEDBACK]}
          disabled={!canEdit || !isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Form.Item
        label={t('Probability to ask for feedback')}
        rules={[{ required: true, message: t('Please enter a probability.') }]}
      >
        <InputNumber
          size="large"
          min={0}
          max={100}
          className="fs-base"
          addonAfter="%"
          defaultValue={form.getFieldValue(['responses', responseIndex, 'jumpProbability']) ? form.getFieldValue(['responses', responseIndex, 'jumpProbability']) * 100 : 100}
          disabled={!canEdit || !isEditingPrimaryLanguage}
          onChange={(value) => {
            form.setFieldValue(['responses', responseIndex, 'jumpProbability'], value / 100);
            setHasPendingChanges(true);
          }}
        />
      </Form.Item>

      <Form.Item
        name={[responseIndex, 'jumpProbability']}
        hidden
      >
        <InputNumber />
      </Form.Item>
    </Fragment>
  );
};

UserFeedbackNodeAAForm.propTypes = {
  form: PropTypes.object.isRequired,
  responseIndex: PropTypes.string.isRequired,
  canEdit: PropTypes.bool.isRequired,
  setHasPendingChanges: PropTypes.func.isRequired
};

export default UserFeedbackNodeAAForm;
